import { render, staticRenderFns } from "./promotion.vue?vue&type=template&id=5fb4ac4d&scoped=true"
import script from "./promotion.vue?vue&type=script&lang=js"
export * from "./promotion.vue?vue&type=script&lang=js"
import style0 from "./promotion.vue?vue&type=style&index=0&id=5fb4ac4d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb4ac4d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fb4ac4d')) {
      api.createRecord('5fb4ac4d', component.options)
    } else {
      api.reload('5fb4ac4d', component.options)
    }
    module.hot.accept("./promotion.vue?vue&type=template&id=5fb4ac4d&scoped=true", function () {
      api.rerender('5fb4ac4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketingFunction/wedding/promotion.vue"
export default component.exports